module.exports = __webpack_public_path__ + "img/help.a445a443.png";